export function stripLeadingZeroes(value: string): string {
  while (value.length > 1 && value.startsWith('0'))
    value = value.substring(1);
  return value;
}
